import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"

import { Video, transformLinkUri } from "gatsby-theme-gba"

const VideoEditable = ({ blok }) => {
  let video = blok.video

  video = video.linktype === "url" ? video.url : video.cached_url

  return (
    <SbEditable content={blok}>
      <Video video={video} reverse={blok.reverse}>
        <Markdown
          source={blok.body}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      </Video>
    </SbEditable>
  )
}

export default VideoEditable
